import { Socials } from '../Socials';
import * as styles from './styles.css';

export const Header: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['logo']} />
      <Socials theme="white" />
    </div>
  );
};
